import { Form, InputNumber } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { JobSpec } from 'domains/jobconfigDomain';
import { useTranslation } from 'react-i18next';
import { PLATFORM_FORM_ITEM_LAYOUT } from 'utils/constants';

export const SkuTesterStepServices = ({ spec }: { spec: JobSpec }) => {
  const [form] = useForm();
  const { t } = useTranslation();

  const onFinish = (values: any) => {
    console.log(values);
  };

  return (
    <>
      <div className="sku-tester-wizard-step-title">
        {t('platform.sku.tester.stepServices.pageTitle')}
      </div>
      <div className="sku-tester-wizard-step-content">
        <Form
          layout={'horizontal'}
          form={form}
          {...PLATFORM_FORM_ITEM_LAYOUT}
          onFinish={onFinish}
          autoComplete="off"
          onValuesChange={(values) => {
            console.log('onValues Change', values);
          }}
        >
          <Form.Item
            label={t('platform.sku.tester.stepServices.labels.quantity')}
            name="quantity"
          >
            <InputNumber />
          </Form.Item>
        </Form>
      </div>
    </>
  );
};
